import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiClaude, SiClaudecode } from "react-icons/si";
import { TbRobot } from "react-icons/tb";

function AiTools() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="Claude">
        <SiClaude />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Claude Code">
        <SiClaudecode />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Kilo Code">
        <TbRobot />
      </Col>
    </Row>
  );
}

export default AiTools;
